import React, {useContext} from 'react';
import {Container, Grid} from '@mui/material';
import {Typography} from '@customink/pigment-react';
import {OrderItem} from '@customink/stores-api-client';
import {
  useGetStoreDetailsQuery,
  useGetHybridOrderConfirmationNewQuery
} from '../../api/storesApi';
import {useAppSelector} from '../../hooks';
import MobileProvider, {MobileContext} from '../../containers/MobileProvider';
import StoreHeader from '../../components/StoreHeader';
import OrderConfirmNextSteps from '../../components/OrderConfirmNextSteps';
import Footer from '../../components/Footer';
import OrderProductCard from '../../components/OrderProductCard';
import BuyupOrderDetailsCard from '../../components/BuyupOrderDetailsCard';
import OrderConfirmBanner from '../../components/OrderConfirmBanner';
import './index.scss';

export interface Props {
  storeSlug: string;
  campaignId: string;
}
const CONTRIBUTION_PRODUCT_NAME = 'Organizer Contribution' as const;

const BuyupConfirmationLayout: React.FC<Props> = ({
  storeSlug,
  campaignId
}: Props): React.ReactElement => {
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  const mobile = useContext(MobileContext);
  const buyupConfirmationClasses = `buyup-confirmation-layout${
    mobile ? ' mobile' : ''
  }`;

  const {data: orderConfirmationData} = useGetHybridOrderConfirmationNewQuery({
    storeSlug,
    campaignId
  });
  const campaign = orderConfirmationData?.campaign;
  const email = orderConfirmationData?.organizer?.email;
  const serviceChargesDetails =
    orderConfirmationData?.campaign?.serviceChargesDetails;

  const orderProducts = orderConfirmationData?.individual?.items;
  const orderContributionItem = orderProducts?.find((item: OrderItem) => {
    return item?.productName === CONTRIBUTION_PRODUCT_NAME;
  });

  return storeDetails ? (
    <div className={buyupConfirmationClasses}>
      <MobileProvider>
        <StoreHeader storeSlug={storeSlug} preview={false} />
      </MobileProvider>

      <Container className="buyup-confirmation-layout-body">
        <Grid container spacing={3}>
          <Grid item lg={12} xs={12} className="orderConfirmBannerAndNextStep">
            <OrderConfirmBanner
              storeName={storeDetails?.name}
              mobile={mobile}
              placeholder={!storeDetails?.name}
            />
            <OrderConfirmNextSteps organizerEmail={email} />
          </Grid>
          <Grid
            item
            lg={7}
            md={6}
            sm={12}
            xs={12}
            className="orderProductCardGrid">
            <div className="orderProductCardHeader">
              <Typography className="orderProductCardTitle bold" gutterBottom>
                Your Items
              </Typography>

              <div
                className={`orderProductCardOrder${mobile ? ' mobile' : ''}`}>
                <Typography className="orderNumber" weight="bold" variant="h6">
                  Order #{serviceChargesDetails?.referenceId}
                </Typography>

                <Typography className="status">
                  Paid <br />
                  Estimated Delivery: N/A
                </Typography>
              </div>
            </div>
            <OrderProductCard
              productImage={null}
              productName={orderContributionItem?.productName}
              productColor={null}
              decorationMethod={null}
              unitPrice={serviceChargesDetails?.serviceCharges}
              sizes={{}}
              isOrganizerContributionItem
              placeholder={!orderContributionItem}
            />
          </Grid>
          <Grid
            item
            lg={5}
            md={6}
            sm={12}
            xs={12}
            className="orderDetailsCardGrid">
            <BuyupOrderDetailsCard
              campaign={campaign}
              storeSlug={storeSlug}
              serviceChargesDetails={serviceChargesDetails}
              placeholder={
                !serviceChargesDetails?.referenceId ||
                !serviceChargesDetails?.creditCardLastFour
              }
              mobile={mobile}
            />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  ) : null;
};

export default BuyupConfirmationLayout;
